module.exports = __webpack_public_path__ + "static/media/19fa5f_154193d7f92f4af6b42b18d8799ff1de~mv2.472bfa8b.webp";